var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddColumnBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C20.55 20 21.0208 19.8042 21.4125 19.4125C21.8042 19.0208 22 18.55 22 18V4C22 3.45 21.8042 2.97917 21.4125 2.5875C21.0208 2.19583 20.55 2 20 2H16C15.45 2 14.9792 2.19583 14.5875 2.5875C14.1958 2.97917 14 3.45 14 4V18C14 18.55 14.1958 19.0208 14.5875 19.4125C14.9792 19.8042 15.45 20 16 20H20ZM16 4H20V18H16V4Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 4H6V14H4V4C4 3.45 4.19584 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H10C10.55 2 11.0208 2.19583 11.4125 2.5875C11.8042 2.97917 12 3.45 12 4V18C12 18.55 11.8042 19.0208 11.4125 19.4125C11.0208 19.8042 10.55 20 10 20V4H9.9Z",
    fill: "#3DDB69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20V22H4V20H2V18H4V16H6V18H8V20H6Z",
    fill: "#3DDB69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddColumnBefore);
export default __webpack_public_path__ + "static/media/add_column_before.73fd43346b254fc5c982c5b600942129.svg";
export { ForwardRef as ReactComponent };